export const enUi = {
  // Launcher: boot, loading and error recovery.
  "ui.cheatCodeAccepted": "CHEAT CODE ACCEPTED",
  "ui.accessingMassifDeepSpaceNetwork":
    "ACCESSING MASSIF DEEP SPACE NETWORK...",
  "ui.640kMemoryOk": "640K MEMORY OK",
  "ui.loadingScrumExe": "LOADING SCRUM.EXE...",
  "ui.loadingSectorArt": "LOADING SECTOR ART...",
  "ui.diskReadError": "DISK READ ERROR",
  "ui.abortRetryFail": "ABORT, RETRY, FAIL?",
  "ui.retry": "RETRY",
  "ui.abort": "ABORT",

  // Launcher: controls and language menu.
  "ui.showControls": "Show controls",
  "ui.hideControls": "Hide controls",
  "ui.language": "Language",
  "ui.soundOff": "Sound off",
  "ui.soundOn": "Sound on",
  "ui.fullscreen": "Fullscreen",
  "ui.exitFullscreen": "Exit fullscreen",
  "ui.exit": "Exit",

  // Game: resume choices, dialogue and inventory controls.
  "ui.continue": "Continue",
  "ui.newGame": "New game",
  "ui.textSpeed": "TEXT SPEED",
  "ui.more": "More...",
  "ui.mancomb": "Mancomb",
  "ui.useWith": "Use {item} with {target}",
};
